import * as React from 'react'
import styled from 'styled-components'
import Svg from './Svg'

function BaseComponent(props: any) {
  return (
    <Svg
      width={15}
      height={15}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 7.5A.5.5 0 01.5 7H3a.5.5 0 010 1H.5a.5.5 0 01-.5-.5zm5.75 0a.5.5 0 01.5-.5h2.5a.5.5 0 010 1h-2.5a.5.5 0 01-.5-.5zM12 7a.5.5 0 000 1h2.5a.5.5 0 000-1H12z"
        fill="currentColor"
      />
    </Svg>
  )
}

const SvgBorderDashed = styled(BaseComponent)`
  outline: none;
`
export default SvgBorderDashed
